import { IconType } from "@jsq/ds/core";
import { Colors } from "@jsq/ds/styles";
import { RequestedDocumentType } from "../../../graphql/supergraph.index";
import { allDocumentsUploaded } from "../DocumentCollectorInvestor/utils";

export const getDocumentStatusInfo = (
  documentTypes: RequestedDocumentType[],
): {
  message: string;
  iconType: IconType;
  color: Colors;
} | null => {
  const hasMissing = !allDocumentsUploaded(documentTypes);
  if (hasMissing) {
    return {
      message: "Additional documents required",
      iconType: "exclamation-triangle",
      color: Colors.Neutral600,
    };
  }
  return null;
};
